import { connect } from "react-redux";
import { createSelector } from "reselect";
import { Maybe } from "true-myth";

import {
  deleteShift,
  openBlockModal,
  OpenBlockFunc,
} from "actions/scheduling/blocks";
import { deleteUnavail } from "actions/scheduling";
import { selectStoreLocation } from "store/select/account";
import { ILocation } from "types/account";
import { IPosUser, IShift, IUnavailabilityBlock } from "types/schedules";

interface IMapStateToProps {
  storeLocation: Maybe<ILocation>;
}

const mapStateToPropsSelector = createSelector(
  selectStoreLocation,
  (storeLocation): IMapStateToProps => ({ storeLocation })
);

interface IMapDispatchToProps {
  deleteShift: (shift: IShift, assignee: Maybe<IPosUser>) => void;
  deleteUnavail: (unavail: IUnavailabilityBlock) => void;
  openBlockModal: OpenBlockFunc;
}

const mapDispatchToProps: IMapDispatchToProps = {
  deleteShift,
  deleteUnavail,
  openBlockModal,
};

export default connect(
  mapStateToPropsSelector,
  mapDispatchToProps
);
